import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/errors';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class PaymentGatewayService {
  constructor(private http: HttpClient) {}

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getSettlementByTenantId(tenantId: number, allparams: any): Observable<any> {
    let parsedParams = new HttpParams();
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    return this.http
      .get(`${environment.BASE_URL}/tenants/${tenantId}/pos/settlements`, {
        headers: this.httpOptions.headers,
        params: parsedParams,
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  exportSettlementByTenantId(tenantId: number,payload: any): Observable<any> {
    return this.http
      .post(`${environment.BASE_URL}/tenants/${tenantId}/pos/settlements/export`, payload,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  downloadSettlementById(tenantId: number,id:number,payload: any): Observable<any> {
    return this.http
      .post(`${environment.BASE_URL}/tenants/${tenantId}/pos/settlements/${id}`, payload,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

}
